<div class="w-full flex flex-col flex-1 min-h-0">
<div class="flex flex-col flex-1 min-h-0 overflow-hidden">

  <!-- Primera carga: tabla Skeleton -->
  @if (loading() && !initialLoadDone()) {
    <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <p-skeleton width="8rem" height="1.5rem" class="mb-2" />
            <p-skeleton width="14rem" height="0.875rem" />
          </div>
          <div class="w-full sm:w-auto flex justify-end">
            <p-skeleton width="10rem" height="2.5rem" />
          </div>
        </div>
      </div>
      <div class="flex-1 min-h-0 overflow-auto">
        <table class="w-full border-collapse">
          <thead class="bg-slate-50 border-b border-slate-200">
            <tr>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Folio</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Cliente</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Plan</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Estado</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Fecha</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Subtotal</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Total</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Acciones</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-slate-100">
            @for (row of skeletonRows; track row) {
              <tr>
                <td class="px-2 py-2"><p-skeleton width="7rem" height="0.875rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="8rem" height="0.875rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="8rem" height="0.875rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="4rem" height="1.25rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="5rem" height="0.875rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="5rem" height="0.875rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="5rem" height="0.875rem" /></td>
                <td class="px-2 py-2 text-right"><p-skeleton width="4rem" height="2rem" /></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="bg-slate-50 px-6 py-4 border-t border-slate-200 flex justify-between items-center shrink-0">
        <p-skeleton width="8rem" height="2rem" />
        <p-skeleton width="12rem" height="2rem" />
      </div>
    </div>
  }

  <!-- Error State -->
  @if (error() && !loading()) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <div class="flex items-center">
        <i class="pi pi-exclamation-triangle text-red-600 mr-2"></i>
        <p class="text-red-800">{{ error() }}</p>
      </div>
      <button
        (click)="loadSubscriptions()"
        class="mt-3 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
        Reintentar
      </button>
    </div>
  }

  <!-- Tabla -->
  @if (initialLoadDone() && !error()) {
    <div class="flex-1 min-h-0 flex flex-col">
      <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
          <div class="grid grid-cols-1 sm:grid-cols-[1fr_auto_1fr] items-center gap-4">
            <div>
              <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
                <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-teal-100 text-teal-600">
                  <i class="pi pi-sync"></i>
                </span>
                Suscripciones
              </h2>
              <p class="text-sm text-slate-500 mt-1">
                @if (viewMode() === 'timeline') {
                  Próximas renovaciones ordenadas por fecha de cobro.
                } @else {
                  Listado de suscripciones activas y pasadas.
                }
              </p>
            </div>
            <span class="inline-flex justify-self-center rounded-lg border border-slate-200 bg-white p-0.5 shadow-sm" role="group" aria-label="Tipo de vista">
              <button
                type="button"
                class="inline-flex items-center gap-1 rounded-md px-2 py-1.5 text-xs font-medium transition-colors"
                [class.bg-teal-100]="viewMode() === 'table'"
                [class.text-teal-800]="viewMode() === 'table'"
                [class.text-slate-600]="viewMode() !== 'table'"
                (click)="setViewMode('table')"
                pTooltip="Vista tabla"
                tooltipPosition="bottom"
              >
                <i class="pi pi-table"></i>
                <span class="hidden sm:inline">Tabla</span>
              </button>
              <button
                type="button"
                class="inline-flex items-center gap-1 rounded-md px-2 py-1.5 text-xs font-medium transition-colors"
                [class.bg-teal-100]="viewMode() === 'timeline'"
                [class.text-teal-800]="viewMode() === 'timeline'"
                [class.text-slate-600]="viewMode() !== 'timeline'"
                (click)="setViewMode('timeline')"
                pTooltip="Vista timeline de próximas renovaciones"
                tooltipPosition="bottom"
              >
                <i class="pi pi-calendar"></i>
                <span class="hidden sm:inline">Timeline</span>
              </button>
            </span>
            <div class="w-full sm:w-auto flex flex-wrap items-center justify-end gap-2">
              <p-button
                label="Actualizar"
                icon="pi pi-refresh"
                severity="secondary"
                size="small"
                [rounded]="true"
                [loading]="viewMode() === 'timeline' ? timelineLoading() : loading()"
                (onClick)="refreshTable()"
                pTooltip="Actualizar listado con los filtros actuales"
                tooltipPosition="left"
                appendTo="body" />
              <a routerLink="/subscriptions/nuevo" class="inline-block" appDisableUnless="SUBSCRIPTION_WRITE">
                <p-button label="Nueva Suscripción" icon="pi pi-plus" severity="primary" size="small" appDisableUnless="SUBSCRIPTION_WRITE" />
              </a>
            </div>
          </div>
        </div>

        <!-- Filtros (solo tabla) -->
        <div [formGroup]="filtersForm" class="border-b border-slate-200 bg-slate-50 shrink-0 px-3 py-2 min-h-[2.75rem]">
          @if (viewMode() === 'table') {
          <div class="grid grid-cols-2 xl:flex xl:flex-wrap xl:items-end gap-2">
            <div class="min-w-0 xl:w-32">
              <p-floatlabel class="w-full" variant="on">
                <p-iconfield class="w-full">
                  <input pInputText id="filterSubsNumber" formControlName="number" class="w-full p-inputtext-sm" autocomplete="off" />
                  @if (filtersForm.controls.number.value) {
                    <p-inputicon class="pi pi-times text-sm cursor-pointer" (click)="filtersForm.controls.number.setValue('', { emitEvent: false }); applyFilters()" />
                  }
                </p-iconfield>
                <label for="filterSubsNumber">Folio</label>
              </p-floatlabel>
            </div>
            <div class="min-w-0 col-span-2 sm:col-span-1 xl:flex-1 xl:min-w-40">
              <p-floatlabel class="w-full" variant="on">
                <p-iconfield class="w-full">
                  <p-inputicon class="pi pi-search text-sm" />
                  <input pInputText id="filterSubsQ" formControlName="q" class="w-full p-inputtext-sm" autocomplete="off" />
                  @if (filtersForm.controls.q.value) {
                    <p-inputicon class="pi pi-times text-sm cursor-pointer" (click)="filtersForm.controls.q.setValue('', { emitEvent: false }); applyFilters()" />
                  }
                </p-iconfield>
                <label for="filterSubsQ">Cliente o RFC</label>
              </p-floatlabel>
            </div>
            <p-floatlabel class="w-full min-w-0 xl:w-44" variant="on">
              <p-select
                formControlName="status"
                inputId="filterSubsStatus"
                [options]="statusFilterOptions"
                optionLabel="label"
                optionValue="value"
                size="small"
                [showClear]="true"
                class="w-full" />
              <label for="filterSubsStatus">Estado</label>
            </p-floatlabel>
            <p-floatlabel class="w-full min-w-0 col-span-2 sm:col-span-1 xl:w-64" variant="on">
              <p-datepicker
                inputId="filterSubsCreatedAt"
                formControlName="createdAtRange"
                selectionMode="range"
                [readonlyInput]="true"
                dateFormat="dd/mm/yy"
                showIcon
                iconDisplay="input"
                [showClear]="true"
                size="small"
                class="w-full" />
              <label for="filterSubsCreatedAt">Rango F. creación</label>
            </p-floatlabel>
            <p-floatlabel class="w-full min-w-0 xl:w-32" variant="on">
              <p-select
                formControlName="state"
                inputId="filterSubsState"
                [options]="stateFilterOptions"
                optionLabel="label"
                optionValue="value"
                size="small"
                [showClear]="true"
                class="w-full" />
              <label for="filterSubsState">Estatus</label>
            </p-floatlabel>
            @if (hasActiveFilters()) {
              <div class="flex items-end col-span-2 sm:col-span-1">
                <p-button
                  icon="pi pi-times"
                  [rounded]="true"
                  [text]="true"
                  size="small"
                  severity="secondary"
                  type="button"
                  (onClick)="clearFilters()"
                  ariaLabel="Limpiar filtros" />
              </div>
            }
          </div>
          } @else {
            <div class="flex flex-wrap items-center justify-between gap-2 min-h-[2.25rem]">
              <p class="text-xs text-slate-400">
                <i class="pi pi-calendar-clock mr-1.5 text-[11px]"></i>
                Próximas renovaciones por fecha de cobro
              </p>
              <span class="inline-flex rounded-lg border border-slate-200 bg-white p-0.5 shadow-sm" role="group" aria-label="Agrupación del timeline">
                <button
                  type="button"
                  class="inline-flex items-center gap-1 rounded-md px-2 py-1 text-[11px] font-medium transition-colors"
                  [class.bg-teal-100]="timelineGrouping() === 'day'"
                  [class.text-teal-800]="timelineGrouping() === 'day'"
                  [class.text-slate-600]="timelineGrouping() !== 'day'"
                  (click)="setTimelineGrouping('day')"
                  pTooltip="Agrupar por día"
                  tooltipPosition="bottom"
                >
                  <i class="pi pi-calendar"></i>
                  <span>Diaria</span>
                </button>
                <button
                  type="button"
                  class="inline-flex items-center gap-1 rounded-md px-2 py-1 text-[11px] font-medium transition-colors"
                  [class.bg-teal-100]="timelineGrouping() === 'month'"
                  [class.text-teal-800]="timelineGrouping() === 'month'"
                  [class.text-slate-600]="timelineGrouping() !== 'month'"
                  (click)="setTimelineGrouping('month')"
                  pTooltip="Agrupar por mes"
                  tooltipPosition="bottom"
                >
                  <i class="pi pi-calendar-plus"></i>
                  <span>Mensual</span>
                </button>
              </span>
            </div>
          }
        </div>

        @if (viewMode() === 'table') {
        <div class="flex-1 min-h-0 overflow-hidden">
          <p-table
            #dtSubscriptions
            [value]="subscriptions()"
            dataKey="id"
            [lazy]="true"
            [scrollable]="true"
            scrollHeight="flex"
            [totalRecords]="totalItems()"
            [first]="currentPage() * pageSize()"
            [rows]="pageSize()"
            [rowsPerPageOptions]="pageSizeOptions"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Suscripciones"
            [loading]="loading()"
            [paginator]="true"
            sortMode="single"
            [sortField]="sortField()"
            [sortOrder]="sortOrder()"
            (onLazyLoad)="onLazyLoad($event)"
            [tableStyle]="{ width: '100%' }"
            styleClass="subs-primeng-table p-datatable-striped p-datatable-sm"
            [rowHover]="true"
            paginatorStyleClass="!border-0 !bg-transparent !pt-4 !flex !items-center !justify-between"
          >
            <ng-template pTemplate="paginatorleft">
              <span
                class="inline-flex"
                [pTooltip]="exportButtonTooltip"
                tooltipPosition="top"
                appendTo="body">
                <p-button
                  label="Exportar CSV"
                  icon="pi pi-download"
                  severity="secondary"
                  size="small"
                  [rounded]="true"
                  [loading]="exporting()"
                  [disabled]="!canExportSubscriptions || exporting() || totalItems() === 0"
                  (onClick)="exportCsv()" />
              </span>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th class="!px-2" pSortableColumn="number">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Folio</span>
                    @if (sortField() === 'number') {
                      <p-sortIcon field="number" />
                    }
                  </span>
                </th>
                <th class="!px-2" pSortableColumn="customer.comercialName">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Cliente</span>
                    @if (sortField() === 'customer.comercialName') {
                      <p-sortIcon field="customer.comercialName" />
                    }
                  </span>
                </th>
                <th class="!px-2">Plan</th>
                <th class="!px-2 !whitespace-nowrap" pSortableColumn="status">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Estado</span>
                    @if (sortField() === 'status') {
                      <p-sortIcon field="status" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap !text-center" pSortableColumn="createdAt">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>F. creación</span>
                    @if (sortField() === 'createdAt') {
                      <p-sortIcon field="createdAt" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap !text-right hidden sm:table-cell">Subtotal</th>
                <th class="!px-2 !whitespace-nowrap !text-right">Total</th>
                <th class="!px-2 !whitespace-nowrap !text-right">Acciones</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-sub>
              <tr
                class="cursor-pointer hover:!bg-teal-50/50 transition-colors !border-slate-100"
                (click)="openSubscriptionDetails(sub)"
                [pTooltip]="getSubscriptionNotesTooltip(sub)"
                [tooltipDisabled]="!hasSubscriptionNotes(sub)"
                tooltipPosition="top"
                tooltipStyleClass="subs-notes-tooltip"
                appendTo="body"
              >
                <td class="!px-2 !py-2 !border-slate-100">
                  <div class="flex items-center gap-2">
                    <div
                      [class]="getStatusIconClasses(sub) + ' !h-8 !w-8 [&>i]:text-sm'"
                      [pTooltip]="isSubscriptionInactive(sub) ? 'Inactivo' : getStatusLabel(sub.status)"
                      tooltipPosition="top"
                    >
                      <i [class]="getStatusIcon(sub)"></i>
                    </div>
                    <div class="min-w-0">
                      <div class="text-sm font-medium text-slate-900 truncate">{{ sub.number || '—' }}</div>
                      <span class="block text-[11px] text-slate-400 mt-0.5 font-normal truncate">
                        {{ getCollectionMethodLabel(sub.collectionMethod) }}
                      </span>
                    </div>
                  </div>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 max-w-[12rem]">
                  <div class="min-w-0">
                    <div
                      class="text-sm text-slate-900 truncate"
                      [pTooltip]="getCustomerName(sub)"
                      tooltipPosition="top"
                    >{{ getCustomerName(sub) || '—' }}</div>
                    @if (getCustomerEmail(sub); as email) {
                      <span class="block text-[11px] text-slate-400 mt-0.5 font-normal truncate">{{ email }}</span>
                    }
                  </div>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 max-w-[12rem]">
                  <div class="min-w-0">
                    <div class="text-sm text-slate-900 truncate">{{ getFrequencyLabel(sub.frequency) }}</div>
                    <span
                      class="block text-[11px] text-slate-400 mt-0.5 font-normal truncate"
                      [class.italic]="!sub.plan?.name"
                      [pTooltip]="sub.plan?.name || ''"
                      tooltipPosition="top"
                    >{{ sub.plan?.name || 'Sin plan' }}</span>
                  </div>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 !whitespace-nowrap">
                  <p-tag class="!text-xs" [severity]="getStatusSeverity(sub.status)" [value]="getStatusLabel(sub.status)" />
                </td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-600 !whitespace-nowrap !text-center">
                  {{ sub.createdAt ? (sub.createdAt | date:'dd/MM/yyyy') : '-' }}
                </td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-600 !whitespace-nowrap !text-right hidden sm:table-cell">
                  {{ (sub.subtotal ?? 0) | number:'1.2-2' }}
                </td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm font-medium text-slate-900 !whitespace-nowrap !text-right">
                  {{ (sub.total ?? 0) | number:'1.2-2' }}
                </td>
                <td class="!px-2 !py-2 !border-slate-100 !text-right !whitespace-nowrap" (click)="$event.stopPropagation()">
                  <span class="inline-flex items-center gap-0.5">
                    <p-button icon="pi pi-pen-to-square" rounded [text]="true" severity="secondary" pTooltip="Editar" tooltipPosition="top" styleClass="hover:!bg-sky-100" (onClick)="editSubscription(sub, $event)" appDisableUnless="SUBSCRIPTION_WRITE" />
                    <p-button icon="pi pi-trash" rounded [text]="true" severity="danger" (onClick)="openDeleteModal(sub, $event)" appDisableUnless="SUBSCRIPTION_WRITE" />
                  </span>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="8" class="!px-2 !py-12 !text-center !text-slate-500 !border-slate-100">
                  No se encontraron suscripciones con los filtros aplicados.
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        }

        @if (viewMode() === 'timeline') {
          <div
            #timelineScrollHost
            class="subs-timeline-scroll flex-1 min-h-0 overflow-y-auto"
            (scroll)="onTimelineScroll($event)"
          >
            @if (timelineLoading() && timelineGroups().length === 0) {
              <div class="flex flex-col items-center justify-center py-20 gap-3">
                <i class="pi pi-spin pi-spinner text-3xl text-teal-500"></i>
                <p class="text-sm text-slate-600">Cargando próximas renovaciones…</p>
              </div>
            } @else if (timelineGroups().length === 0) {
              <div class="flex flex-col items-center justify-center py-20 gap-3 text-center px-6">
                <span class="flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 text-slate-400">
                  <i class="pi pi-calendar text-2xl"></i>
                </span>
                <p class="text-sm font-semibold text-slate-800">No hay renovaciones próximas</p>
                <p class="text-xs text-slate-500 max-w-md leading-relaxed">
                  No hay suscripciones activas con fecha de cobro futura que coincidan con tu búsqueda.
                </p>
              </div>
            } @else {
              <div class="flex flex-col min-h-full">
                <div class="flex-1 px-4 sm:px-6 py-6 max-w-3xl mx-auto w-full">
                <div class="subs-timeline-rail">
                  @for (group of timelineGroups(); track group.dateKey; let i = $index) {
                    @if (isNewTimelineMonth(group, i)) {
                      <div class="subs-timeline-month">{{ group.monthTitle }}</div>
                    }

                    <section class="subs-timeline-day" [attr.data-urgency]="group.urgency">
                      <div
                        class="subs-timeline-date-chip"
                        [class.subs-timeline-month-chip]="timelineGrouping() === 'month'"
                      >
                        <span class="subs-timeline-day-num">{{ group.dayNumber }}</span>
                        <span class="subs-timeline-month-lbl">{{ group.monthLabel }}</span>
                      </div>

                      <div class="subs-timeline-day-body">
                        <button
                          type="button"
                          class="subs-timeline-day-head subs-timeline-day-toggle"
                          [class.is-collapsed]="!isTimelineGroupExpanded(group.dateKey)"
                          [attr.aria-expanded]="isTimelineGroupExpanded(group.dateKey)"
                          (click)="toggleTimelineGroup(group.dateKey, $event)"
                        >
                          <div class="min-w-0 flex-1">
                            <div class="flex flex-wrap items-center gap-2">
                              <h3 class="text-sm font-semibold text-slate-900">{{ group.title }}</h3>
                              @if (timelineGrouping() === 'day' || group.subtitle) {
                                <span
                                  class="subs-timeline-countdown"
                                  [attr.data-urgency]="group.urgency"
                                >
                                  <i class="pi pi-clock text-[9px]"></i>
                                  @if (timelineGrouping() === 'day') {
                                    {{ group.subtitle || getRenewalRelativeLabel({ nextBillingDate: group.dateKey }) }}
                                  } @else {
                                    {{ group.subtitle }}
                                  }
                                </span>
                              }
                            </div>
                            <p class="text-[11px] text-slate-500 mt-0.5">
                              {{ group.count }} {{ group.count === 1 ? 'renovación' : 'renovaciones' }}
                              · {{ formatTimelineMoney(group.totalAmount, group.totalCurrency) }}
                            </p>
                          </div>
                          <span class="subs-timeline-day-toggle-chevron" aria-hidden="true">
                            <i
                              class="pi transition-transform duration-150"
                              [class.pi-chevron-down]="isTimelineGroupExpanded(group.dateKey)"
                              [class.pi-chevron-right]="!isTimelineGroupExpanded(group.dateKey)"
                            ></i>
                          </span>
                        </button>

                        @if (isTimelineGroupExpanded(group.dateKey)) {
                        @if (isTimelineGroupLoading(group.dateKey)) {
                          <div class="flex items-center justify-center gap-2 py-6 text-xs text-slate-500">
                            <i class="pi pi-spin pi-spinner text-teal-500"></i>
                            Cargando renovaciones…
                          </div>
                        } @else {
                        <div class="space-y-2 mt-2">
                          @for (sub of group.items; track sub.id + '-' + sub.nextBillingDate) {
                            <article
                              class="subs-timeline-card group"
                              [attr.data-urgency]="getRenewalUrgency(sub)"
                              (click)="openSubscriptionDetails(sub)"
                              [pTooltip]="getSubscriptionNotesTooltip(sub)"
                              [tooltipDisabled]="!hasSubscriptionNotes(sub)"
                              tooltipPosition="top"
                              tooltipStyleClass="subs-notes-tooltip"
                              appendTo="body"
                            >
                              <div
                                [class]="getStatusIconClasses(sub) + ' !h-9 !w-9 shrink-0 [&>i]:text-sm'"
                                [pTooltip]="isSubscriptionInactive(sub) ? 'Inactivo' : getStatusLabel(sub.status)"
                                tooltipPosition="top"
                              >
                                <i [class]="getStatusIcon(sub)"></i>
                              </div>

                              <div class="min-w-0 flex-1 grid grid-cols-1 sm:grid-cols-[minmax(0,1.35fr)_minmax(0,1fr)_auto] gap-x-4 gap-y-1.5 items-center">
                                <div class="min-w-0">
                                  <p class="text-sm font-medium text-slate-900 truncate">{{ getCustomerName(sub) || '—' }}</p>
                                  <p class="text-[11px] text-slate-400 truncate mt-0.5">
                                    <span class="font-mono">{{ sub.number || '—' }}</span>
                                    @if (getCustomerEmail(sub); as email) {
                                      <span class="text-slate-300 mx-1">·</span>
                                      <span>{{ email }}</span>
                                    }
                                  </p>
                                </div>

                                <div class="min-w-0 hidden sm:block">
                                  <p class="text-sm text-slate-700 truncate">{{ sub.plan?.name || 'Sin plan' }}</p>
                                  <p class="text-[11px] text-slate-400 truncate mt-0.5">
                                    {{ getFrequencyLabel(sub.frequency) }} · {{ getCollectionMethodLabel(sub.collectionMethod) }}
                                  </p>
                                </div>

                                <div class="flex items-center gap-2 sm:justify-end">
                                  <div class="sm:text-right min-w-0">
                                    <p class="text-sm font-semibold text-slate-900 tabular-nums">{{ formatSubscriptionMoney(sub) }}</p>
                                    <p class="text-[10px] text-teal-600/80 mt-0.5 sm:hidden">
                                      {{ formatRenewalDate(sub.nextBillingDate) }}
                                    </p>
                                  </div>
                                  <p-tag class="!text-[10px] shrink-0" [severity]="getStatusSeverity(sub.status)" [value]="getStatusLabel(sub.status)" />
                                  <i class="pi pi-chevron-right text-[10px] text-slate-300 shrink-0 group-hover:text-teal-500 transition-colors"></i>
                                </div>
                              </div>
                            </article>
                          }

                          @if (hasMoreTimelineGroupItems(group.dateKey)) {
                            <div class="subs-timeline-group-more">
                              @if (isTimelineGroupLoadingMore(group.dateKey)) {
                                <div class="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-[11px] text-slate-600 shadow-sm">
                                  <i class="pi pi-spin pi-spinner text-teal-500"></i>
                                  Cargando más…
                                </div>
                              } @else {
                                <p class="text-[11px] text-slate-400">Desplázate para ver más en este {{ timelineGrouping() === 'month' ? 'mes' : 'día' }}</p>
                                <div
                                  class="h-px w-full"
                                  [attr.data-group-sentinel]="group.dateKey"
                                  aria-hidden="true"
                                ></div>
                              }
                            </div>
                          }
                        </div>
                        }
                        }
                      </div>
                    </section>
                  }
                </div>
                </div>

                <footer class="shrink-0 mt-auto px-4 sm:px-6 pb-6 pt-2 max-w-3xl mx-auto w-full">
                  @if (timelineLoadingMore()) {
                    <div class="flex justify-center">
                      <div class="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-xs text-slate-600 shadow-sm">
                        <i class="pi pi-spin pi-spinner text-teal-500"></i>
                        Cargando más…
                      </div>
                    </div>
                  } @else if (timelineHasMore()) {
                    <p class="text-center text-xs text-slate-400">Desplázate para ver más renovaciones</p>
                    <div #timelineScrollSentinel class="h-px w-full" aria-hidden="true"></div>
                  } @else if (timelineGroups().length > 0) {
                    <div class="flex justify-center">
                      <p class="inline-flex items-start sm:items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium text-slate-700 shadow-sm max-w-lg text-center leading-snug">
                        <i class="pi pi-flag text-teal-600 shrink-0 mt-0.5 sm:mt-0"></i>
                        <span>No hay más resultados. Solo se pueden visualizar renovaciones hasta {{ timelineHorizonYears }} años desde hoy.</span>
                      </p>
                    </div>
                  }
                </footer>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

</div>

  <!-- Drawer detalle -->
  <p-drawer
    [visible]="isDetailsOpen()"
    position="right"
    (visibleChange)="onDrawerVisibleChange($event)"
    styleClass="subscription-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-teal-100 text-teal-600 shadow-sm">
            <i class="pi pi-sync text-base"></i>
          </span>
          <h3 class="text-lg font-semibold text-slate-900">Detalle de suscripción</h3>
        </div>
        @if (selectedSubscription() && !detailsLoading()) {
          <button
            type="button"
            class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
            (click)="editFromModal()">
            <i class="pi pi-pencil text-sm"></i>
            Editar
          </button>
        }
      </div>
    </ng-template>
    @if (detailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando detalle...</p>
      </div>
    } @else if (selectedSubscription()) {
      <app-subscription-read
        [subscription]="selectedSubscription()!"
        (openSale)="openSaleDetails($event)"
        (openCustomer)="openCustomerDetails($event)" />
    }
  </p-drawer>

  <p-drawer
    [visible]="isSaleDetailsOpen()"
    position="right"
    (visibleChange)="onSaleDrawerVisibleChange($event)"
    styleClass="subscription-sale-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-violet-100 text-violet-600 shadow-sm">
            <i class="pi pi-shopping-cart text-base"></i>
          </span>
          <h3 class="text-lg font-semibold text-slate-900">Detalle de venta</h3>
        </div>
        @if (selectedSale() && !saleDetailsLoading()) {
          <button
            type="button"
            class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
            (click)="editSaleFromModal()">
            <i class="pi pi-pencil text-sm"></i>
            Editar
          </button>
        }
      </div>
    </ng-template>
    @if (saleDetailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando venta...</p>
      </div>
    } @else if (selectedSale()) {
      <app-sale-read
        [sale]="selectedSale()!"
        [charges]="saleCharges()"
        (openCustomer)="openCustomerDetails($event)"
        (openSubscription)="openSubscriptionDetailsById($event)" />
    }
  </p-drawer>

  <p-drawer
    [visible]="isCustomerDetailsOpen()"
    position="right"
    (visibleChange)="onCustomerDrawerVisibleChange($event)"
    styleClass="subscription-customer-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600 shadow-sm">
            <i class="pi pi-user text-base"></i>
          </span>
          <h3 class="text-lg font-semibold text-slate-900">Detalles del cliente</h3>
        </div>
        @if (selectedCustomer() && !customerDetailsLoading()) {
          <button
            type="button"
            class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
            (click)="editCustomerFromModal()">
            <i class="pi pi-pencil text-sm"></i>
            Editar
          </button>
        }
      </div>
    </ng-template>
    @if (customerDetailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando cliente...</p>
      </div>
    } @else if (selectedCustomer()) {
      <app-customer-read
        [customer]="selectedCustomer()!"
        (openSale)="openSaleDetails($event)" />
    }
  </p-drawer>

  <!-- Modal eliminar -->
  @if (deleteModalOpen()) {
    <div class="fixed inset-0 z-50 flex items-center justify-center">
      <div class="absolute inset-0 bg-black transition-opacity duration-300 ease-out"
        [class.bg-opacity-50]="deleteModalShown()" [class.bg-opacity-0]="!deleteModalShown()"
        (click)="closeDeleteModal()"></div>
      <div class="relative bg-white rounded-xl shadow-xl w-full max-w-md p-6 z-10 transform transition-all duration-300 ease-out"
        [class.opacity-100]="deleteModalShown()" [class.opacity-0]="!deleteModalShown()"
        [class.scale-100]="deleteModalShown()" [class.scale-95]="!deleteModalShown()">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold text-slate-900">Confirmar eliminación</h3>
          <button type="button" class="text-slate-500 hover:text-slate-700" (click)="closeDeleteModal()">
            <i class="pi pi-times"></i>
          </button>
        </div>
        <p class="text-sm text-slate-600 mb-6">
          ¿Está seguro de eliminar la suscripción de "{{ getCustomerName(subscriptionToDelete()) || '—' }}" (#{{ subscriptionToDelete()?.id }})? Esta acción no se puede deshacer.
        </p>
        <div class="flex justify-end gap-3">
          <p-button label="Cancelar" severity="secondary" (onClick)="closeDeleteModal()" type="button" />
          <p-button label="Eliminar" severity="danger" icon="pi pi-trash" [loading]="deleteLoading()" [disabled]="deleteLoading()" (onClick)="confirmDeleteSubscription()" type="button" />
        </div>
      </div>
    </div>
  }
</div>
